var _path, _rect, _g, _rect2, _g2, _rect3, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.253 1.29989C12.1707 0.779782 13.294 0.779783 14.2116 1.29989L17.9692 3.42967L21.6924 5.61891C22.6016 6.15355 23.1633 7.1264 23.1717 8.18114L23.206 12.5002L23.1717 16.8192C23.1633 17.8739 22.6016 18.8468 21.6924 19.3814L17.9692 21.5706L14.2116 23.7004C13.294 24.2205 12.1707 24.2205 11.253 23.7004L7.49549 21.5706L3.77227 19.3814C2.86303 18.8468 2.30136 17.8739 2.29297 16.8192L2.25864 12.5002L2.29297 8.18114C2.30136 7.12639 2.86303 6.15355 3.77227 5.61891L7.49549 3.42967L11.253 1.29989Z",
    fill: "var(--iconSecondary)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3146_10415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 9,
    width: 13,
    height: 3
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.73242,
    y: 9,
    width: 12,
    height: 2.66667,
    fill: "var(--iconPrimary)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3146_10415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39917 8.6665L7.49253 8.96992C7.8791 10.2263 9.65016 10.2469 10.0658 8.99984V8.99984",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7324 9V9C13.1595 10.2813 14.972 10.2813 15.3991 9V9",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0657 9V9C10.4928 10.2813 12.3052 10.2813 12.7323 9V9",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3992 8.99984V8.99984C15.8149 10.2469 17.5859 10.2263 17.9725 8.96992L18.0658 8.6665",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3146_10415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 12,
    width: 13,
    height: 3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.73242,
    y: 12.3335,
    width: 12,
    height: 2.66667,
    fill: "var(--iconPrimary)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3146_10415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39917 12L7.49253 12.3034C7.8791 13.5598 9.65016 13.5804 10.0658 12.3333V12.3333",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7324 12.3335V12.3335C13.1595 13.6148 14.972 13.6148 15.3991 12.3335V12.3335",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0657 12.3335V12.3335C10.4928 13.6148 12.3052 13.6148 12.7323 12.3335V12.3335",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3992 12.3333V12.3333C15.8149 13.5804 17.5859 13.5598 17.9725 12.3034L18.0658 12",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3146_10415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 13,
    height: 4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.73242,
    y: 15.6665,
    width: 12,
    height: 2.66667,
    fill: "var(--iconPrimary)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3146_10415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.39917 15.3335L7.49253 15.6369C7.8791 16.8933 9.65016 16.9139 10.0658 15.6668V15.6668",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7324 15.6665V15.6665C13.1595 16.9479 14.972 16.9479 15.3991 15.6665V15.6665",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0657 15.6665V15.6665C10.4928 16.9479 12.3052 16.9479 12.7323 15.6665V15.6665",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3992 15.6668V15.6668C15.8149 16.9139 17.5859 16.8933 17.9725 15.6369L18.0658 15.3335",
    stroke: "var(--iconPrimary)",
    strokeWidth: 0.85
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.af4276385c0704997e7a8b96504e2095.svg";
export { ForwardRef as ReactComponent };